module.exports = __webpack_public_path__ + "static/media/small-circle-tick.c2937457.svg";